// TEMPORARY - remove once migration 402 ran on CEO_Dashboard (then delete this file, its test, and the import plus the two effectiveModuleId calls in useEffectivePermissions.ts).
//
// The page Vertragszeit-Abgleich used to share the right of the Personalübersicht ('hr-dashboard'). It has its own module now
// ('hr-vertragszeit-abgleich', rows by migration 402). Between the deploy and the migration no role holds a row for it, so the page
// and the sidebar entry would vanish for the three roles that use it today. Until then the old right applies.
//
// Rule (same as requireVzAccess in functions/intranet/src/lib/vertragszeitAbgleich.js): while the caller's effective module map
// has NO entry for the module (not even Role-Admin's "Kein Zugriff" = a row with read false / write false), the old module counts.
// A map with the entry never falls back, so a right the owner takes away in the matrix stays taken away.

/** new module id -> the module whose right applies while the new one has no row at all */
export const MODULE_FALLBACK: Readonly<Record<string, string>> = {
  'hr-vertragszeit-abgleich': 'hr-dashboard',
}

/** The module id whose right decides for `moduleId`, given the caller's effective module map (/api/me/permissions). */
export function effectiveModuleId(modules: unknown, moduleId: string): string {
  const fallback = MODULE_FALLBACK[moduleId]
  if (!fallback || !modules || typeof modules !== 'object') return moduleId
  return Object.prototype.hasOwnProperty.call(modules, moduleId) ? moduleId : fallback
}
